export default __webpack_public_path__ + "static/media/ble3.2cc5ca17.png";